import { type BaseOperatorType } from 'advanced-filters/data';

import styles from './FilterListItemSeperator.module.scss';

export default function FilterListItemSeperator({
  operator,
}: {
  operator: BaseOperatorType;
}) {
  return (
    <div className={styles.seperator}>
      <div className={styles.seperatorLine} />
      <div className={styles.seperatorContent}>{operator}</div>
      <div className={styles.seperatorLine} />
    </div>
  );
}
